var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._b({attrs:{"fluid":"","pa-0":""}},'v-container',_vm.$attrs,false),[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }